import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Header: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Clear Navigation Bar */}
      <nav className="py-3 px-6 backdrop-blur-sm mb-6">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
            <Logo />
            <div className="text-left">
              <div className="text-white text-xl font-bold">Quote Vibes Daily</div>
              <p className="text-white opacity-80 text-xs">Find the right words, right when you need them.</p>
            </div>
          </Link>
          
        </div>
      </nav>
    </header>
  );
};

export default Header; 